module.exports = __webpack_public_path__ + "static/media/halo-clean-image.7a9652ed.svg";